import React, {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {push} from 'connected-react-router'
import ReactPaginate from 'react-paginate'
import {filtersSelector, paginationSelector} from '../selectors'
import createPathByFilters from '../utils/createPathByFilters'
import trackEvent from '../../../utils/track-event'

export default function Pagination(props) {
    const {isCustomStore} = props
    const dispatch = useDispatch()
    const filters = useSelector((state) =>
        filtersSelector(state, isCustomStore)
    )
    const pagination = useSelector(paginationSelector)
    const [isFirstForcingPage, setIsFirstForcingPage] = useState(true)

    const handlePageChange = ({selected}) => {
        if (isFirstForcingPage) {
            setIsFirstForcingPage(false)
            return
        }

        const page = selected + 1
        const url = createPathByFilters(filters, {
            page,
        })

        dispatch(push(url))

        if (page !== filters.page) {
            trackEvent({
                category: 'store button',
                action: 'Switch listing page',
                label: String(page),
            })
        }
    }

    const hrefBuilder = (page) => {
        if (page === filters.page) return ''

        return createPathByFilters(filters, {
            page,
        })
    }

    const loadMoreProducts = (e) => {
        const url = e.target.dataset.href

        dispatch(
            push(url, {
                addProducts: true,
            })
        )

        trackEvent({
            category: 'store button',
            action: 'Button load more click',
        })
    }

    const nextPage = createPathByFilters(filters, {
        page: +filters.page + 1,
    })

    return (
        <If condition={pagination.pageCount}>
            <If condition={pagination.pageCount !== filters.page}>
                <button
                    data-href={nextPage}
                    onClick={loadMoreProducts}
                    className="b-btn b-btn_default"
                >
                    Еще принты
                </button>
            </If>
            <ReactPaginate
                previousLabel={''}
                nextLabel={''}
                initialPage={+filters.page - 1}
                forcePage={+filters.page - 1}
                breakLabel={<a>...</a>}
                breakClassName={'break-me'}
                pageCount={pagination.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageChange}
                containerClassName={'b-pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                hrefBuilder={hrefBuilder}
            />
        </If>
    )
}
